export default __webpack_public_path__ + "static/media/CapacitorImg.0aeb1f48.jpg";